import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";

import createAppStore from "./redux/store";
import Loader from "./common/loaders/Loader";
import App from "./App";

function AppContainer() {
  const [store, setStore] = useState(null);

  useEffect(() => {
    let mounted = true;

    const initializeStore = async () => {
      try {
        const appStore = await createAppStore();
        if (mounted) setStore(appStore);
      } catch (err) {
        // Swallow init errors to avoid user-facing messages; app will still render
        console.warn(
          "App initialization encountered an issue; continuing.",
          err
        );
      }
    };

    initializeStore();
    return () => {
      mounted = false;
    };
  }, []);

  if (!store) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
}

export default AppContainer;
